// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * APPEND-ONLY. The members below carry no explicit `= N`, so `FlatBuffers`
 * numbers them by declaration order and the ordinal IS the wire value.
 *
 * Inserting, reordering or removing a member silently renumbers every member
 * after it, which reinterprets every archived message and every frame in
 * flight — with no error anywhere, because the wire value stays a valid
 * member of the enum, just a different one. New values go LAST, always.
 */
export enum Fault {
  LowerPitSwitch = 0,
  PowerLoss = 1,
  UpperCombImpact = 2,
  Overspeed = 3,
  DoorDoesNotClose = 4,
  StartPermitRelay = 5,
  Overload = 6,
  Drive = 7,
  EmergencyPower = 8,
  Earthquake = 9,
  DoorTimedOutClosing = 10,
  CarNotAvailable = 11,
  DriveNotAvailable = 12,
  DoorTimedOutOpening = 13,
  HallButtonFailureBussFuseBlown = 14,
  CarDelayedExessively = 15,
  DoorOpenAndDoorLockConcurrently = 16,
  OutOfServiceWithDoorLock = 17,
  OutOfServiceWithoutDoorLock = 18,
  LostDoorLockWhileRunning = 19,
  PhotoCellDectector = 20,
  SafetyEdgeFailure = 21,
  HoistwaySafetyCircuitOpen = 22,
  GovernorSwitchOpen = 23,
  CarSafetyCircuitOpen = 24,
  CarTopSwitchOpen = 25,
  CommunicationLoss = 26,
  Reset = 27,
  Position = 28,
  BinaryInput = 29,
  DoorZone = 30,
  Stalled = 31,
  DoorOpen = 32,
  DoorClose = 33,
  Up = 34,
  Down = 35,
  HoistwayLearn = 36,
  StopSwitch = 37,
  DPRInput = 38,
  LcFuseBlown = 39,
  HcFuseBlown = 40,
  PositionInputOff = 41,
  CarSafety = 42,
  UlOrDlOff = 43,
  DeltaOff = 44,
  UtCount = 45,
  Ut1Count = 46,
  Ut2Count = 47,
  Ut3Count = 48,
  DtCount = 49,
  Dt1Count = 50,
  Dt2Count = 51,
  Dt3Count = 52,
  RearDoorOpen = 53,
  RearDoorClose = 54,
  Car1CommLoss = 55,
  Car2CommLoss = 56,
  Car3CommLoss = 57,
  Car4CommLos = 58,
  Car5CommLoss = 59,
  Car6CommLoss = 60,
  RunIoFailedOn = 61,
  RunORunA_I = 62,
  RunIoFailedOff = 63,
  RunAIoFailedOn = 64,
  RunAIoFailedOff = 65,
  UpIoFailedOn = 66,
  UpIoFailedOff = 67,
  DnrIoFailedOn = 68,
  DnrIoFailedOff = 69,
  UpfIoFailedOn = 70,
  UpfIoFailedOff = 71,
  DfIoFailedOn = 72,
  DfIoFailedOff = 73,
  MsIoFailedOn = 74,
  Run0Run1Failed = 75,
  MsIoFailedOff = 76,
  McIoFailedOn = 77,
  McIoFailedOff = 78,
  BrkIoFailedOn = 79,
  BrkIoFailedOff = 80,
  DonIoFailedOff = 81,
  RunA = 82,
  TopDoorLock = 83,
  MidDoorLock = 84,
  BotDoorLock = 85,
  GateSwitch = 86,
  RearTopLock = 87,
  RearMidLock = 88,
  RearBotLock = 89,
  RearGateSwitch = 90,
  PInputOff = 91,
  EmergencyStop = 92,
  InspectionInput = 93,
  GateLockBypassSwitch = 94,
  Grt1InputOn = 95,
  Grt1InputOff = 96,
  Grt2InputOn = 97,
  Grt2InputOff = 98,
  GripperDidNotPick = 99,
  GripperTrip = 100,
  DlTopAndDlTop1Opposite = 101,
  DlMidAndDlMid1Opposite = 102,
  DlBotAndDlBot1Opposite = 103,
  GateSwitchAndGateSwitch1Opposite = 104,
  RlmAndRlm1Opposite = 105,
  RgsAndRgs1Opposite = 106,
  BrakePick = 107,
  BrakeDrop = 108,
  BrakeSetGripper = 109,
  DeltaOn = 110,
  CwtSwitchErrorAtDT = 111,
  CwtSwitchErrorAtUT = 112,
  TargetAtUT = 113,
  TargetAtUT1 = 114,
  TargetAtUT2 = 115,
  TargetAtUt3 = 116,
  TargetAtDT = 117,
  TargetAtDT1 = 118,
  TargetAtDT2 = 119,
  TargetAtDT3 = 120,
  HcComDevice = 121,
  CarComDevice = 122,
  TocCANComm = 123,
  DriveComRecv = 124,
  PowerUpReset = 125,
  PossibleDrv1028Er = 126,
  CarSafePreop = 127,
  CarSafeStart = 128,
  InspectionUpDnSwitch = 129,
  DriveComTrmError = 130,
  DriveComIntError = 131,
  DriveComTxEmptyEr = 132,
  UTSCount = 133,
  DTSCount = 134,
  TargetAtUTS = 135,
  TargetAtDTS = 136,
  DriveCom8259 = 137,
  DriveComTxStopEr = 138,
  SpbCANCom = 139,
  DbrTemperature = 140,
  SebCANCom = 141,
  LwCalibration = 142,
  CANChipInit = 143,
  RunShutdown = 144,
  BadFloorTable = 145,
  CarGateOpen = 146,
  ContactorDropTimer = 147,
  GateLock = 148,
  DerailmentDoorOpen = 149,
  DownDirectionalSwitch = 150,
  NoBalanceComplete = 151,
  CanNotDetermineMode = 152,
  NoRetriesLeft = 153,
  SequenceTimers = 154,
  HoistwaySafetyString = 155,
  SafetyStringOpen = 156,
  UpDirectionalSwitch = 157,
  VelocityNotZero = 158,
  TopNetFeedback = 159,
  BottomNetFeedback = 160,
  DriveSerialLink = 161,
  BrakeFeedbackContact = 162,
  FrontDoorObstruction = 163,
  RearDoorObstruction = 164,
  FrontPhotocell = 165,
  RearPhotocell = 166,
  TimedOutOfService = 167,
  PositionNotKnown = 168,
  DriveShutdown = 169,
  DoorSafetyOpen = 170,
  EmergencyStopOpen = 171,
  SerialNTSError = 172,
  InitFailure = 173,
  CounterWeightDerailed = 174,
  StartProtect = 175,
  Brake = 176,
  Motion = 177,
  FrontDoorFailedToOpenClose = 178,
  RearDoorFailedToOpenClose = 179,
  CarCommunicationLoss = 180,
  NoCommWithMapOrGroup = 181,
  ServiceProtect = 182,
  ShuntTrip = 183,
  EmergencyDispatch = 184,
  UnintendedMotion = 185,
  RescueOperations = 186,
  RunMonitorFailure = 187,
  Selector = 188,
  FrontHoistDoorWatchdog = 189,
  RearHoistDoorWaatchdog = 190,
  FrontCarDoorWatchdog = 191,
  RearCarDoorWatchdog = 192,
  DiagnosticsCarLockout = 193,
  LowOil = 194,
  Viscosity = 195,
  LoadweigherShutdown = 196,
  CheckedRedundancyShutdown = 197,
  RetiringCamFailure = 198,
  FrontDoorCommLoss = 199,
  RearDoorCommLoss = 200,
  InvalidInspection = 201,
  FloodedPit = 202,
  FrontDoorCloseLimitConflict = 203,
  FrontDoorOpenLimitConflict = 204,
  RearDoorCloseLimitConflict = 205,
  RearDoorOpenLimitConflict = 206,
  DoorZoneSensor = 207,
  Entrapment = 208,
  UpsActivated = 209,
  UpsBatteryFailure = 210,
  HallCallStuck = 211,
  PlcFault = 212,
  PlcBattery = 213,
  GlassWindowSwitch = 214,
  ExcessiveTravelTime = 215,
  WeightSensor = 216,
  PowerSupplyFailure = 217,
  NormalLimitSwitch = 218,
  JumperDetected = 219,
  RelayFault = 220,
  PrCircuitFault = 221,
  NtsdRelay = 222,
  IstRelay = 223,
  ContactorRelay = 224,
  StartMonitor = 225,
  SpeedCpuFault = 226,
  RedundancyFault = 227,
  SystemCheck = 228,
  StepSagSwitch = 229,
  MotorLimitTimer = 230,
  MissingStepSensor = 231,
  OilLevel = 232,
  LubricationLevel = 233,
  WaterDetection = 234,
  MotorOverheat = 235,
  SensorFault = 236,
  MemoryCorrupted = 237,
  RelevellingSensor = 238,
  WrongAdjustment = 239,
  SimultaneousSensorFault = 240,
  SleepModeEntered = 241,
  SleepModeExited = 242,
  AlarmButtonPressed = 243,
  SwingModeOn = 244,
  HospitalPhase1Fault = 245,
  HospitalPhase2Fault = 246,
  SecurityActivated = 247,
  AlarmBellNoMovement = 248,
  CarToFloorFault = 249,
  CarToLobbyFault = 250,
  PowerTransferInput = 251,
  CommunicationsEstablished = 252,
  DoorCircuitBreaker = 253,
  SoftStartFailure = 254,
  RamHeadSwitch = 255,
  RecycleFailure = 256,
  EscapeHatch = 257,
  PlankSwitch = 258,
  DispatcherHmiFailure = 259,
  WildCallActive = 260,
  SlackCableSwitch = 261,
  TopFinalLimit = 262,
  BottomFinalLimit = 263,
  RollerWorn = 264,
  ThirdRailEngaged = 265,
  EgressDoorMidshaft = 266,
  MachineAccessDoor = 267,
  LadderKeyCircuit = 268,
  ManualBrakeRelease = 269,
  TravellingCablePullout = 270,
  StuckCarCallButton = 271,
  StuckDoorCloseButton = 272,
  StuckDoorOpenButton = 273,
  DataLinkInoperative = 274,
  OpdInoperative = 275,
  DiodeOverheat = 276,
  DriveInputContactor = 277,
  UpsWeeklyTest = 278,
  AuxPowerCircuit = 279,
  RoofDoorAccess = 280,
  RopeTensionSwitch = 281,
  DoorProtectionOpen = 282,
  GovernorSlackRope = 283,
  SafetyPlankSwitch = 284,
  CompensationCableSwitch = 285,
  SideExitDoor = 286,
  LimitBoard = 287,
  HoistMotorField = 288,
  EncoderDeviation = 289,
  EncoderGuideWear = 290,
  FailShutdownEncoderCom = 291,
  IoLine24VLost = 292,
  ScrRegulatorTripped = 293,
  StrainGauge = 294,
  SpeedDifferential = 295,
  PwaStartMissing = 296,
  GeneratorFailedStart = 297,
  GeneratorFailedShutOff = 298,
  StuckPawlMagnet = 299,
  NoFault = 300,
  DoorContactError = 301,
  DoorLimitProblem = 302,
  PhotoSwitchError = 303,
  ReLevelingProblem = 304,
  LowOilAst = 305,
  NoStatusPanelPower = 306,
  NoFrontDoorPower = 307,
  CarDummyRun = 308,
  Phase1Bypass = 309,
  ColdOilBypass = 310,
  RayCurtainProblem = 311,
  K40Mismatch = 312,
  FrontCamStuck = 313,
  RearCamStuck = 314,
  FrontGateRelay = 315,
  RearGateRelay = 316,
  FrontGateStuck = 317,
  RearGateStuck = 318,
  FrontLockRelay = 319,
  RearLockRelay = 320,
  FrontLockStuck = 321,
  RearLockStuck = 322,
  RelayPickError = 323,
  HandPickError = 324,
  TerminalSwitchError = 325,
  DoorCamStuck = 326,
  DoorHangup = 327,
  MovingNoPulses = 328,
  NoRiserPower = 329,
  StopOverrideActive = 330,
  TooFastTsd = 331,
  TooSlowTsd = 332,
  TooManyEms = 333,
  UnnecessaryTsd = 334,
  LvhmCommBad = 335,
  DroppedSignal = 336,
  PickedSignal = 337,
  LzdStaysOn = 338,
  MoveNotRunning = 339,
  ValveTimeout = 340,
  CallButtonsStuck = 341,
  SafetyJumped = 342,
  TestCondition = 343,
  NeedToLearn = 344,
  FireStopSwitch = 345,
  DoorCloseFailFault = 346,
  DoorOpenFailFault = 347,
  SwingCloseFault = 348,
  DriveEnableRelay = 349,
  RedundantGovernor = 350,
  FloodFault = 351,
  RelayFeedback = 352,
  SfhFault = 353,
  PreflightCheck = 354,
  RedundantMrInput = 355,
  UntsAndDnts = 356,
  SetNts = 357,
  SetEts = 358,
  SetTsrd = 359,
  EmergencyMedicalOperation = 360,
  SecurityFaultCode = 361,
  FloorSensorFault = 362,
  IoMapCompareFault = 363,
  IoMapToggleFault = 364,
  VectorChecksumFault = 365,
  ConfigChecksumFault = 366,
  ConfigVectorCrosscheck = 367,
  LearnSwitchTimeout = 368,
  FaultBypassSwitchTimeout = 369,
  SibDeviceFault = 370,
  ImpConfigMismatch = 371,
  VectorLearnFault = 372,
  ConfigLearnFault = 373,
  QpramDeviceError = 374,
  EepromDeviceError = 375,
  SingleChannelQuadFault = 376,
  LossPositionIndicators = 377,
  VectorComparisonFault = 378,
  VectorCreationFault = 379,
  SafFault = 380,
  ExcessiveFaultShutdown = 381,
  DoorCloseFailFront = 382,
  DoorCloseFailRear = 383,
  DoorOpenFailFront = 384,
  DoorOpenFailRear = 385,
  DoorContactFaultFront = 386,
  DoorContactFaultRear = 387,
  HallCallBusFailure = 388,
  CartopCommFault = 389,
  SpbIosFault = 390,
  SpbLosFault = 391,
  SpbCosFault = 392,
  SpbUetsFault = 393,
  SpbDetsFault = 394,
  CnpmdFault = 395,
  CnpmFault = 396,
  CnpbdFault = 397,
  CnpbFault = 398,
  IbcfFault = 399,
  FloorLocationFault = 400,
  ExcessiveRelevelsFault = 401,
  ExcessiveRestartsFault = 402,
  InsufficientFieldVoltage = 403,
  FieldFailure = 404,
  RgLegShortFault = 405,
  ScrLowLineFault = 406,
  ScrLowLineCaution = 407,
  GovSpeedReductionFault = 408,
  TachError = 409,
  DroFault = 410,
  BpsFault = 411,
  OverTemperature = 412,
  UserDefined = 413,
  LuFail = 414,
  LdFail = 415,
  Es2ScOpenFail = 416,
  DdiComms = 417,
  EvacBatteryFault = 418,
  SpeedSlip = 419,
  EncoderFault = 420,
  RtcFail = 421,
  BatteryFail = 422,
  DispatchHwFail = 423,
  LightrayFail = 424,
  MaxErrors = 425,
  NoLevelUpSignal = 426,
  NoLevelDownSignal = 427,
  SlotOverflow = 428,
  OpenTerminal = 429,
  AuxPowerLowering = 430,
  Communication2Fail = 431,
  TrRelayFail = 432,
  ResynchFailed = 433,
  UslAndDslOn = 434,
  CommFailTinyIo = 435,
  UpSpeedLimitFail = 436,
  DnSpeedLimitFail = 437,
  No24Volts = 438,
  No5Volts = 439,
  OtherFaults = 440,
  MicroprocessorSafety = 441,
  WrongWayTrip = 442,
  MovingNotRunning = 443,
  EmergencyExitSwitch = 444,
  TopNormStopSwitch = 445,
  TopLockFailure = 446,
  IntermediateLockFailure = 447,
  TopSlowdownMalfunction = 448,
  SumpPumpOverflow = 449,
  OilInPit = 450,
  OilLeakJack = 451,
  MotorRoomHighTemp = 452,
  CommonAlarm = 453,
  FilterStatusFault = 454,
  LeakAlarm = 455,
  OilOverTemperature = 456,
  NoCommWithGroup = 457,
  SpareFault = 458,
  AttemptedOverspeed = 459,
  B2ContactorOpen = 460,
  BContactorFailed = 461,
  BContactorOpen = 462,
  BelowBottonDZ = 463,
  BothuetAndDets = 464,
  CPUStopSwitch = 465,
  Car7CommLos = 466,
  Car8CommLoss = 467,
  CarBypassSwitch = 468,
  CarLost = 469,
  CarNetwork = 470,
  CheckGSW = 471,
  CheckInterlock = 472,
  ContactorNotClosed = 473,
  CorrectionRun = 474,
  DriveConfiguration = 475,
  DriveNotReady = 476,
  ETSOverspeed = 477,
  ErrorClosingsMRelay = 478,
  ErrorOpoeningsMRelay = 479,
  FaultLogAutoClear = 480,
  FaultsCleared = 481,
  GroupNetwork = 482,
  HallBypassSwitch = 483,
  HallCallNodeError = 484,
  HighSpeedTest = 485,
  InCarStop = 486,
  InvalidContractSpeed = 487,
  InvalidHighSpeed = 488,
  InvalidInspectionSpeed = 489,
  LearnError = 490,
  LostDCL = 491,
  LostGateSwitchOutsideDZ = 492,
  LostSaf = 493,
  LowPressure = 494,
  MContactorFailed = 495,
  MContactorOpen = 496,
  MotorNotUpToSpeed = 497,
  MotorStopFailed = 498,
  MotorTimerLimit = 499,
  OutOfService = 500,
  RedudantAccess = 501,
  RedudantCarBypass = 502,
  RedundanTuets = 503,
  RedundantBottomLock = 504,
  RedundantDets = 505,
  RedundantFireStop = 506,
  RedundantGateSwitch = 507,
  RedundantHallBypass = 508,
  RedundantICStop = 509,
  RedundantInspection = 510,
  RedundantInspic = 511,
  RedundantMiddleLock = 512,
  RedundantRearGateSwitch = 513,
  RedundantTopLock = 514,
  Saf1CloseFailure = 515,
  Saf1OpenFail = 516,
  Saf2CloseFailure = 517,
  Saf2OpenFail = 518,
  SafetyConfiguration = 519,
  SavedConfiguration = 520,
  SpeedDeviationError = 521,
  SpineTCT = 522,
  SpineTMR = 523,
  TedundantInsPmr = 524,
  Earthquake2 = 525,
  CommunicationLossToGroup = 526,
  InitializationShutdown = 527,
  GovernorOpen = 528,
  SafetyHStringOpen = 529,
  FrontPhotoEyeFailure = 530,
  RearPhotoEyeFailure = 531,
  LandingSystemSensorFault = 532,
  MotorContactorProofingFault = 533,
  UpDirectionLimitOpen = 534,
  BrakeEnableFault = 535,
  BrakeCurrentNotOffFault = 536,
  InsufficientBrakeCurrentFeedback = 537,
  BrakeVoltageNotOnFault = 538,
  BrakeIgbtFault = 539,
  BrakeModuleOverTemperatureFault = 540,
  HeatSensorFault2 = 541,
  HeatSensorFault3 = 542,
  HeatSensorFault4 = 543,
  PowerSupplyFault1 = 544,
  PowerSupplyFault2 = 545,
  PowerSupplyFault3 = 546,
  PowerSupplyFault4 = 547,
  DriveAtSpeedFault = 548,
  FrontDoorCloseTimeout = 549,
  FrontDoorOpenTimeout = 550,
  RearDoorCloseTimeout = 551,
  RearDoorOpenTimeout = 552,
  MainFireServiceRecall = 553,
  AltFireServiceRecall = 554,
  InCarFiremanService = 555,
  ElevatorRecallSwitch1 = 556,
  ElevatorRecallSwitch2 = 557,
  ElevatorRecallSwitch3 = 558,
  ElevatorRecallSwitch4 = 559,
  ElevatorRecallSwitch5 = 560,
  ElevatorRecallSwitch6 = 561,
  FrontDoorContactMonitoringFault = 562,
  RearDoorContactMonitoringFault = 563,
  FrontSafeEdgeFailure = 564,
  RearSafeEdgeFailure = 565,
  InCarInspectionOperation = 566,
  HoistwayAccessOperation = 567,
  TestMode = 568,
  CaptureMode = 569,
  IndependentService = 570,
  HospitalEmergencyService = 571,
  InCarHospitalEmergencyService = 572,
  AttendantService = 573,
  PassengerOperation = 574,
  PositionFaultUnt1 = 575,
  PositionFaultUnt2 = 576,
  PositionFaultUnt3 = 577,
  PositionFaultUnt4 = 578,
  PositionFaultUnt5 = 579,
  PositionFaultUets = 580,
  PositionFaultDnt1 = 581,
  PositionFaultDnt2 = 582,
  PositionFaultDnt3 = 583,
  PositionFaultDnt4 = 584,
  PositionFaultDnt5 = 585,
  PositionFaultDets = 586,
  PositionQuadratureFailure = 587,
  QuadratureSpeedThresholdFault = 588,
  QuadratureSpeedDeviationFault = 589,
  MotionStartFailure = 590,
  InvalidLogicalIndicatorAccess = 591,
  EmergencyPowerNoSupervisorShutdown = 592,
  EmergencyPowerNoSupervisorDeactivated = 593,
  CarDelayedDoorsOpen = 594,
  CarOutOfServiceDoorsOpen = 595,
  CarOutOfServiceDoorsClosed = 596,
  EarthquakeBoardPowerOn = 597,
  EarthquakeBoardPowerOff = 598,
  EarthquakeResetButtonStuck = 599,
  EarthquakeResetButtonOk = 600,
  FireServicePhaseIIHold = 601,
  FireServicePhaseIIRecall = 602,
  LoadLearnActivated = 603,
  LoadLearnDeactivated = 604,
  CarHeavyLoad = 605,
  FireServiceRecallDeactivated = 606,
  InCarFiremanServiceDeactivated = 607,
  CarLightLoad = 608,
  CarDispatchLoad = 609,
  CarHeavyLoadHallCallsBypassed = 610,
  CarHeavyLoadDeactivated = 611,
  CarHeavyLoadActivated = 612,
  CarOverloadDeactivated = 613,
  PhotoEyeAntinuisance = 614,
  LightLoadAntinuisance = 615,
  NudgingOperation = 616,
  FrontPhotoEyeBypassed = 617,
  RearPhotoEyeBypassed = 618,
  FrontSafeEdgeBypassed = 619,
  RearSafeEdgeBypassed = 620,
  RecallSwitch1Deactivated = 621,
  RecallSwitch2Deactivated = 622,
  RecallSwitch3Deactivated = 623,
  RecallSwitch4Deactivated = 624,
  RecallSwitch5Deactivated = 625,
  RecallSwitch6Deactivated = 626,
  InspectionOverspeedFault = 627,
  TachErrorFault = 628,
  DriveEnableFeedbackFault = 629,
  SpaIosFault = 630,
  IoMapToggleCompareFault = 631,
  SafetyBypassJumperTimeout = 632,
  DeviceSpaSibFault = 633,
  DeviceSpbSibFault = 634,
  DeviceQpramFault = 635,
  DeviceEepromFault = 636,
  FrontDoorOpenButtonBypassed = 637,
  RearDoorOpenButtonBypassed = 638,
  FrontDoorOpenButtonFailure = 639,
  RearDoorOpenButtonFailure = 640,
  DoorLockClippedAbove200Fpm = 641,
  SafetyOpened = 642,
  MotionStopIoToggleTest = 643,
  IoMapCompareAlert = 644,
  SpaCosFault = 645,
  SpaLosFault = 646,
  LimitSwitchesChecksumFault = 647,
  ConfigVectorCrossCheckFault = 648,
  LimitSwitchesLearnFault = 649,
  DualChannelQuadFault = 650,
  PositionSpeedIndicatorFault = 651,
  PositionQuadratureReversedFault = 652,
  Dnt1Level1Fault = 653,
  Dnt2Level1Fault = 654,
  Dnt3Level1Fault = 655,
  Dnt4Level1Fault = 656,
  Dnt5Level1Fault = 657,
  Dnt1Level2Fault = 658,
  Dnt2Level2Fault = 659,
  Dnt3Level2Fault = 660,
  Dnt4Level2Fault = 661,
  Dnt5Level2Fault = 662,
  Unt1Level1Fault = 663,
  Unt2Level1Fault = 664,
  Unt3Level1Fault = 665,
  Unt4Level1Fault = 666,
  Unt5Level1Fault = 667,
  Unt1Level2Fault = 668,
  Unt2Level2Fault = 669,
  Unt3Level2Fault = 670,
  Unt4Level2Fault = 671,
  Unt5Level2Fault = 672,
  SpaDetsLevel2Fault = 673,
  SpaUetsLevel2Fault = 674,
  AscendingCarOverspeedFault = 675,
  PositionSyncRequiredAtTerminal = 676,
  PositionSyncedAtTerminal = 677,
  PositionSyncRequiredAtFloor = 678,
  PositionSyncedAtFloor = 679,
  CartopInspectionUnintendedMotionFault = 680,
  CartopAutomaticUnintendedMotionFault = 681,
  SpbFaultBypassSwitchTimeout = 682,
  SpbSafetyBypassJumperTimeout = 683,
  IoMapCompareLongTermAlert = 684,
  IoMapCompareLongTermFault = 685,
  PositionLocationErrorFault = 686,
  PositionCartopOffsetFault = 687,
  SpbUetsLevel2Fault = 688,
  SpbDetsLevel2Fault = 689,
  CartopEmergencyStop = 690,
  CartopPowerLoss = 691,
  DownDirectionLimitOpen = 692,
  PowerTransferActivated = 693,
  PowerTransferDeactivated = 694,
  InvalidFrontDoorPosition = 695,
  InvalidRearDoorPosition = 696,
  CartopInspectionOperation = 697,
  CarPanelInspectionOperation = 698,
  HoistwayAccessInspectionOperation = 699,
  MachineRoomInspectionOperation = 700,
  InspectionOperation = 701,
  CartopInspectionConstructionOperation = 702,
  CarPanelInspectionConstructionOperation = 703,
  HoistwayAccessInspectionConstructionOperation = 704,
  MachineRoomInspectionConstructionOperation = 705,
  InspectionConstructionOperation = 706,
  DoorLockClippedBelow200Fpm = 707,
  InvalidInput = 708,
  EmsMedicalRecallSwitch1 = 709,
  EmsMedicalInCarSwitch1 = 710,
  EmsMedicalDeactivated = 711,
  EmsMedicalBypassed = 712,
  ScrPowerSupplyFault = 713,
  ScrAcPhaseFault = 714,
  ScrContactorFuseFault = 715,
  ScrPllFault = 716,
  ScrPllWarning = 717,
  ScrDynamicBrakeFault = 718,
  ScrInstantaneousOverCurrent = 719,
  ScrArmVoltageOn = 720,
  ScrHighTempFault = 721,
  ScrLoopOverCurrent = 722,
  ScrInsufficientArmatureCurrent = 723,
  ScrExcessiveArmatureCurrent = 724,
  ScrExcessiveCurrentCmdDriveEnabled = 725,
  ScrExcessiveCurrentCmdDriveDisabled = 726,
  SwingOperationActivated = 727,
  SwingOperationDeactivated = 728,
  FieldModuleOverTemperatureFault = 729,
  SpeedLimitMfForcing = 730,
  TachFailure = 731,
  SabbathOperationActivated = 732,
  SabbathOperationDeactivated = 733,
  RopeBrakeTripped = 734,
  RopeGripperLeg1ShortFault = 735,
  RopeGripperLeg2ShortFault = 736,
  AuxSpeedProfile1Activated = 737,
  AuxSpeedProfile1Deactivated = 738,
  AuxSpeedProfile2Activated = 739,
  AuxSpeedProfile2Deactivated = 740,
  MotorFieldForcingTimedOut = 741,
  IviewLoggedOn = 742,
  IviewLoggedOff = 743,
  IviewTimedOut = 744,
  IviewLostConnection = 745,
  BalancedMode = 746,
  LobbyPeakMode = 747,
  DemandUpPeakMode = 748,
  DemandDownPeakMode = 749,
  CfssMode1RecallActivated = 750,
  CfssMode1TransitionActivated = 751,
  CfssMode1InCarActivated = 752,
  CfssMode2RecallActivated = 753,
  CfssMode2TransitionActivated = 754,
  CfssMode2InCarActivated = 755,
  EmergencyAlarmAcknowledged = 756,
  EmergencyAlarmActivatedSafetyOpened = 757,
  EmergencyAlarmActivatedCarDelayed = 758,
  EmergencyAlarmActivatedAlarmButton = 759,
  EmergencyAlarmActivatedInCarStop = 760,
  RopeGripperOkFaulted = 761,
  CartopExitOpen = 762,
  SafetyCStringOpen = 763,
  MachineRoomStopSwitchOpen = 764,
  CarStopSwitchOpen = 765,
  ControllerStartup = 766,
  FloorSynchronizationFault = 767,
  TerminalSynchronizationFault = 768,
  PositionSynchronizationFault = 769,
  UpEmergencyTerminalSwitchShutdown = 770,
  DownEmergencyTerminalSwitchShutdown = 771,
  PowerUpPositionSyncRequired = 772,
  TerminalSwitchSpeedsNotLearned = 773,
  TerminalSwitchPositionsNotLearned = 774,
  ExcessiveMotorFieldVoltage = 775,
  BrakeOutputCircuitFailure = 776,
  GroupCommunicationEstablished = 777,
  FloodOperationActivated = 778,
  FloodOperationDeactivated = 779,
  RopeGripperUimResetButtonStuck = 780,
  ExerciseOperationActivated = 781,
  ExerciseOperationDeactivated = 782,
  ScrLowLineCautionActivated = 783,
  ScrLowLineCautionDeactivated = 784,
  ScrLowLineTestFault = 785,
  ExcessiveRestartsWarning = 786,
  GovernorSpeedReductionSwitchFault = 787,
  SoftwareRecallCommandActivated = 788,
  ScrDriveReadyFault = 789,
  RetiringCamDoorLockFaultDeactivated = 790,
  RetiringCamProtectionFaultActivated = 791,
  RetiringCamProtectionFaultDeactivated = 792,
  WatchdogControlStopBeforeReset = 793,
  FrontHallDoorOpenButtonBypassed = 794,
  RearHallDoorOpenButtonBypassed = 795,
  FrontHallDoorOpenButtonFailure = 796,
  RearHallDoorOpenButtonFailure = 797,
  Bus2FuseOpen = 798,
  Bus2DFuseOpen = 799,
  Bus2McFuseOpen = 800,
  Bus2PiFuseOpen = 801,
  Bus3FuseOpen = 802,
  Bus3HaFuseOpen = 803,
  WatchdogEmergencyStopBeforeReset = 804,
  BackupDispatcherActivated = 805,
  BackupDispatcherDeactivated = 806,
  DriveStartFailure = 807,
  EmsMedicalRecallSwitch2 = 808,
  EmsMedicalInCarSwitch2 = 809,
  DoorsLockedFault = 810,
  EmergencyAlarmDeactivatedWithoutAck = 811,
  Underspeed = 812,
  SafetyBreak = 813,
  PhaseFailure = 814,
  SmokeDetector = 815,
  KeySwitchStop = 816,
  ConsecutiveStop = 817,
  MotorUnderspeed = 818,
  ExternalShutdown = 819,
  SeismicMonitor = 820,
  Safety = 821,
  Generic = 822,
  CombplateTopLeft = 823,
  HandrailTopLeft = 824,
  SkirtingTop = 825,
  CombplateBottomLeft = 826,
  HandrailBottomLeft = 827,
  ChaintensionBottom = 828,
  DriveChain = 829,
  HandrailDrop = 830,
  StepUpthrust = 831,
  CombHeating = 832,
  SkirtingBottom = 833,
  Direction = 834,
  BrokenStepBottom = 835,
  StopSwitchTop = 836,
  HandrailStretch = 837,
  StopSwitchBottom = 838,
  FrequencyConverter = 839,
  StopSwitchAuxiliary = 840,
  FloorCoverTop = 841,
  OverspeedTop = 842,
  UnderspeedTop = 843,
  HandrailMonitorLeft = 844,
  HandrailMonitorRight = 845,
  ServiceBrake = 846,
  EmergencyBrake = 847,
  BrokenStepTop = 848,
  SensorInmgb = 849,
  StepAbsenceTop = 850,
  SensorInvkTop = 851,
  StepAbsenceBottom = 852,
  SensorInvkBottom = 853,
  OverspeedBottom = 854,
  UnderspeedBottom = 855,
  SoftStop = 856,
  ParameterLost = 857,
  SreDrop = 858,
  HandrailTopRight = 859,
  HandrailBottomRight = 860,
  CombplateTopRight = 861,
  CombplateBottomRight = 862,
  SafetyCircuit = 863,
  FloorCoverBottom = 864,
  UndefinedStop = 865,
  ContinuousOperation = 866,
  ReadyToStart = 867,
  MotorOnMains = 868,
  AutomaticService = 869,
  EscalatorRunning = 870,
  TUVSimulation = 871,
  InspectionMode = 872,
  LightCurtainActive = 873,
  ResetMHardware = 874,
  ResetS0Hardware = 875,
  ResetS1Hardware = 876,
  ResetS2Hardware = 877,
  ResetS3Hardware = 878,
  ResetDHardware = 879,
  ResetMBussRetry = 880,
  ResetS0BussRetry = 881,
  ResetS1BussRetry = 882,
  ResetS2BussRetry = 883,
  ResetS3BussRetry = 884,
  ResetDBussRetry = 885,
  ResetMBufferFull = 886,
  ResetS0BufferFull = 887,
  ResetS1BufferFull = 888,
  ResetS2BufferFull = 889,
  ResetS3BufferFull = 890,
  ResetDBufferFull = 891,
  ResetMWrongMess = 892,
  ResetS0WrongMess = 893,
  ResetS1WrongMess = 894,
  ResetS2WrongMess = 895,
  ResetS3WrongMess = 896,
  ResetDWrongMess = 897,
  ResetMMaster = 898,
  ResetS0Master = 899,
  ResetS1Master = 900,
  ResetS2Master = 901,
  ResetS3Master = 902,
  ResetDMaster = 903,
  ResetMTimeOut = 904,
  ResetS0TimeOut = 905,
  ResetS1TimeOut = 906,
  ResetS2TimeOut = 907,
  ResetS3TimeOut = 908,
  ResetDTimeOut = 909,
  ResetMFcom = 910,
  ResetS0Fcom = 911,
  ResetS1Fcom = 912,
  ResetS2Fcom = 913,
  ResetS3Fcom = 914,
  ResetDFcom = 915,
  ResetMSlave = 916,
  VoltageOff = 917,
  SmokeDetectorBottom = 918,
  SkirtingMiddle = 919,
  PhaseControl = 920,
  RubberTop = 921,
  RubberBot = 922,
  BlockingDevice = 923,
  CombHeatingTop = 924,
  StepUpthrustBottom = 925,
  BrakeLining = 926,
  DeviceStopByCustomer = 927,
  DeviceWaterLevelBottom = 928,
  ContactorPickUp = 929,
  Handrail = 930,
  SystemFault = 931,
  Undefined = 932,
  StepLevelSwitch = 933,
  GeneralFault = 934,
  SleepMode = 935,
  MotorVibration = 936,
  AccessCoverSwitch = 937,
  OutOfLevelStepDetector = 938,
  AnnunciatorComLost = 939,
  UContactorNotReleased = 940,
  EncoderSignalMissing = 941,
  ReverseDirectionDetected = 942,
  StepBandSpeedLow = 943,
  StepBandSpeedHigh = 944,
  EpromChecksum = 945,
  RamChecksum = 946,
  CpuRelayFault = 947,
  StopTimerFault = 948,
  SafetyRelayFault = 949,
  FireAlarmContacts = 950,
  MultipleSwitchOpen = 951,
  StartUpMode = 952,
  KeySwitchMalfunction = 953,
  LightCurtainOccupied = 954,
  AsymmetricMainSupply = 955,
  PhaseReversal = 956,
  OilLack = 957,
  TemperatureLow = 958,
  RemoteHalt = 959,
  ChainWheel = 960,
  HandwheelStop = 961,
  VfConverterFailure = 962,
  VsafConverterNoStart = 963,
  PowerFailureRelays = 964,
  AutomaticRemoteStop = 965,
  MesbOffLine = 966,
  MissingStepDetected = 967,
  PermittedStopDistanceExceed = 968,
  MesbFaultDetected = 969,
  MesbUnconfigured = 970,
  MesbUnderPoor = 971,
  MesbLearning = 972,
  FpcAddressError = 973,
  FloorPlatesNotOpen = 974,
  BramoAddressError = 975,
  ElectronicOverSpeed = 976,
  NoSynchronizerSignal = 977,
  VfRunOutputError = 978,
  UacCheckError = 979,
  EpromTestError = 980,
  RamTestError = 981,
  Rs4rWiredError = 982,
  E2promCrcError = 983,
  CircuitBreakerTriggered = 984,
  PowerPhasesLost = 985,
  BlowerHeating = 986,
  CombplateHeatingFault = 987,
  StepChainOff = 988,
  CombplateVh = 989,
  MotorStopFault = 990,
  DiagnosticExtra = 991,
  McbStepUpThrust = 992,
  DriveError = 993,
  OverspeedDirection = 994,
  ReversePhaseDetection = 995,
  RunDirectionCheck = 996,
  ManualLubrication = 997,
  SkirtSwitch = 998,
  ImpactDetection = 999,
  EntryDetection = 1000,
  BrokenStepChain = 1001,
  MonitorFault = 1002,
  LobbyButtonFuseCarOpen = 1003,
  HallCallButtonsCarFuseOpen = 1004,
  CarCallAckLightsFuseOpen = 1005,
  DoorZoneMonitorFault = 1006,
  StopSwitchRedundancyFailure = 1007,
  LobbyButtonFuseDispOpen = 1008,
  HallCallButtonsDispFuseOpen = 1009,
  CarOutOfDoorZone = 1010,
  SwingDoorPrimaryDoorLock = 1011,
  ProvingFault = 1012,
  AllOK = 1013,
  CpuPoweredByBcar = 1014,
  EslEtsTrip = 1015,
  MotorThermalTrip = 1016,
  CycleTestFailure = 1017,
  RopeGripperCycleTestFail = 1018,
  NoControl120Vac = 1019,
  BrakeSwitchErrorOnRun = 1020,
  BrakeSwitchErrorOnStop = 1021,
  GateSwitchDoorLockNotRunTos = 1022,
  RopeGripperEmergencyBrakeTripOverspeed = 1023,
  RopeGripperEmergencyBrakeTripUam = 1024,
  RopeGripperEmergencyBrakeTripBkw = 1025,
  RopeGripperEmergencyBrakeTrip = 1026,
  SafetiesOpen = 1027,
  StopSwitchOpen = 1028,
  OlrRprDcOpen = 1029,
  RegenDriveError = 1030,
  DoorLockOnFault = 1031,
  GateSwitchOnFault = 1032,
  SdLimitFailure = 1033,
  NormalLimitFailure = 1034,
  HighSpeedStopGateSwitch = 1035,
  HighSpeedStopDoorLock = 1036,
  CxDclTos = 1037,
  EMCPCPorDMShutdown = 1038,
  DSDNotClosed = 1039,
  ESTOpen = 1040,
  CarGateOpenOutsideOfDoorZone = 1041,
  DoorGateOpenOutsideOfDoorZone = 1042,
  OilOverTemperatureHydrosOnly = 1043,
  OrderSpecific = 1044,
  ContactorDropoutCheck = 1045,
  HandRailEntryBottomRight = 1046,
  HandRailEntryTopRight = 1047,
  MissingStepTop = 1048,
  MonitoringContactorTop = 1049,
  Thermal = 1050,
  F0x00 = 1051,
  F0x01 = 1052,
  F0x02 = 1053,
  F0x03 = 1054,
  F0x04 = 1055,
  F0x05 = 1056,
  F0x06 = 1057,
  F0x07 = 1058,
  F0x08 = 1059,
  F0x09 = 1060,
  F0x0A = 1061,
  F0x0B = 1062,
  F0x0C = 1063,
  F0x0D = 1064,
  F0x0E = 1065,
  F0x0F = 1066,
  F0x18 = 1067,
  F0x1C = 1068,
  F0x20 = 1069,
  F0x21 = 1070,
  F0x22 = 1071,
  F0x23 = 1072,
  F0x27 = 1073,
  F0x29 = 1074,
  F0x37 = 1075,
  F0x40 = 1076,
  F0x42 = 1077,
  F0x43 = 1078,
  F0x46 = 1079,
  F0x47 = 1080,
  F0x5A = 1081,
  F0x5B = 1082,
  F0x5C = 1083,
  F0x5D = 1084,
  F0x5E = 1085,
  F0x60 = 1086,
  F0x61 = 1087,
  F0x62 = 1088,
  F0x63 = 1089,
  F0x64 = 1090,
  F0x65 = 1091,
  F0x66 = 1092,
  F0x67 = 1093,
  F0x68 = 1094,
  F0x69 = 1095,
  F0x6A = 1096,
  F0x6B = 1097,
  F0x6C = 1098,
  F0x6D = 1099,
  F0x6E = 1100,
  F0x6F = 1101,
  F0x70 = 1102,
  F0x71 = 1103,
  F0x72 = 1104,
  F0x73 = 1105,
  F0x74 = 1106,
  F0x75 = 1107,
  F0x76 = 1108,
  F0x77 = 1109,
  F0x78 = 1110,
  F0x79 = 1111,
  F0x7A = 1112,
  F0x7B = 1113,
  F0x7C = 1114,
  F0x7D = 1115,
  F0x7E = 1116,
  F0x7F = 1117,
  F0x80 = 1118,
  F0x81 = 1119,
  F0x82 = 1120,
  F0x83 = 1121,
  F0x84 = 1122,
  F0x85 = 1123,
  F0x86 = 1124,
  F0x87 = 1125,
  F0x88 = 1126,
  F0x89 = 1127,
  F0x8A = 1128,
  F0x8B = 1129,
  F0x8C = 1130,
  F0x8D = 1131,
  F0x8E = 1132,
  F0x8F = 1133,
  F0x90 = 1134,
  F0x91 = 1135,
  F0x92 = 1136,
  F0x93 = 1137,
  F0x94 = 1138,
  F0x95 = 1139,
  F0x96 = 1140,
  F0x97 = 1141,
  F0x98 = 1142,
  F0x99 = 1143,
  F0x9A = 1144,
  F0x9B = 1145,
  F0x9C = 1146,
  F0x9D = 1147,
  F0x9E = 1148,
  F0x9F = 1149,
  F0xCC = 1150,
  F0xCD = 1151,
  F0xCE = 1152,
  F0xCF = 1153,
  F0xD0 = 1154,
  F0xDC = 1155,
  F0xDD = 1156,
  F0xDE = 1157,
  F0xDF = 1158,
  F0xF0 = 1159,
  F0xF1 = 1160,
  F0xF2 = 1161,
  F0xF3 = 1162,
  F0xF4 = 1163,
  F0xF5 = 1164,
  F0xF6 = 1165,
  F0xF7 = 1166,
  F0xF8 = 1167,
  F0xF9 = 1168,
  F0xFA = 1169,
  F0xFB = 1170,
  F0xFC = 1171,
  F0xFD = 1172,
  F0xFE = 1173,
  F0xFF = 1174,
  MotorFailedToStop = 1175,
  DownDirectional = 1176,
  DriveReady = 1177,
  BrakeIOFailedOff = 1178,
  BrakeIOFailedOn = 1179,
  CarComDeviceReset = 1180,
  DonIoFailedOn = 1181,
  GsAndGs1Opposite = 1182,
  HcComDeviceReset = 1183,
  PInputOffFault = 1184,
  PInputOnFault = 1185,
  RunORunAFailed = 1186,
  RunRunADNRFail = 1187,
  RunRunAUpFail = 1188,
  SafetyString = 1189,
  DLBAndDLB1Opposite = 1190,
  DLMAndDLM1Opposite = 1191,
  DLTAndDLT1Opposite = 1192,
  _13 = 1193,
  _24 = 1194,
  _4D = 1195,
  _53 = 1196,
  _E1 = 1197,
  _E2 = 1198,
  _E3 = 1199,
  _E4 = 1200,
  _E5 = 1201,
  _E6 = 1202,
  _E7 = 1203,
  _E8 = 1204,
  _E9 = 1205,
  _EA = 1206,
  _EB = 1207,
  _EC = 1208,
  _ED = 1209,
  _EE = 1210,
  _EF = 1211,
  DelayedCar = 1212,
  DriveOrBrakeFault = 1213,
  DriveOrBrakeSubsystemNotAvailable = 1214,
  BothDlkandDolon = 1215,
  BypassSystem = 1216,
  CarOnEmergencyPower = 1217,
  CarStopBypassRelay = 1218,
  ContactorDropSystem = 1219,
  DoorLockRelays = 1220,
  DoorLockSystem = 1221,
  DoorZoneRelay = 1222,
  EmergencyStopRelay = 1223,
  FrontDoorLimitySystem = 1224,
  GovernorContactSystem = 1225,
  HoistwaySafety = 1226,
  InspectionSwitch = 1227,
  LevelRelay = 1228,
  LostCommunication = 1229,
  LostDlkWhileRunning = 1230,
  MainFireService = 1231,
  RearDoorLimitSystem = 1232,
  StopRelay = 1233,
  UnintendedMovementsSystem = 1234,
  _00 = 1235,
  _01 = 1236,
  _02 = 1237,
  _03 = 1238,
  _04 = 1239,
  _05 = 1240,
  _06 = 1241,
  _07 = 1242,
  _08 = 1243,
  _09 = 1244,
  _0A = 1245,
  _0B = 1246,
  _0C = 1247,
  _0D = 1248,
  _0E = 1249,
  _0F = 1250,
  _18 = 1251,
  _1C = 1252,
  _20 = 1253,
  _21 = 1254,
  _22 = 1255,
  _23 = 1256,
  _27 = 1257,
  _29 = 1258,
  _37 = 1259,
  _40 = 1260,
  _42 = 1261,
  _43 = 1262,
  _46 = 1263,
  _47 = 1264,
  _5A = 1265,
  _5B = 1266,
  _5C = 1267,
  _5D = 1268,
  _5E = 1269,
  _6A = 1270,
  _6B = 1271,
  _6C = 1272,
  _6D = 1273,
  _6E = 1274,
  _6F = 1275,
  _7A = 1276,
  _7B = 1277,
  _7C = 1278,
  _7D = 1279,
  _7E = 1280,
  _7F = 1281,
  _8A = 1282,
  _8B = 1283,
  _8C = 1284,
  _8D = 1285,
  _8E = 1286,
  _8F = 1287,
  _9A = 1288,
  _9B = 1289,
  _9C = 1290,
  _9D = 1291,
  _9E = 1292,
  _9F = 1293,
  _CC = 1294,
  _CD = 1295,
  _CE = 1296,
  _CF = 1297,
  _D0 = 1298,
  _F0 = 1299,
  _F1 = 1300,
  _F2 = 1301,
  _F3 = 1302,
  _F4 = 1303,
  _F5 = 1304,
  _F6 = 1305,
  _F7 = 1306,
  _F8 = 1307,
  _F9 = 1308,
  _FA = 1309,
  _FB = 1310,
  _FC = 1311,
  _FD = 1312,
  _FE = 1313,
  _FF = 1314,
  _DC = 1315,
  _DD = 1316,
  _DE = 1317,
  _DF = 1318,
  RedundantAccess = 1319,
  RedundantCarBypass = 1320,
  RedundantInsPmr = 1321,
  AlarmVibrationsm2 = 1322,
  AlarmVibrationsm1 = 1323,
  Asymmetrty = 1324,
  BrakeLeftm1 = 1325,
  BrakeLeftm2 = 1326,
  BrakeLevelerm2 = 1327,
  BrakeLevlerm1 = 1328,
  BrakeRightm1 = 1329,
  BrakeRightm2 = 1330,
  BrakeweaLeftm1 = 1331,
  BrakewearLeftm2 = 1332,
  BrakewearRightm1 = 1333,
  BrakewearRightm2 = 1334,
  ChaintensionLowerLeft = 1335,
  ChaintensionLowerRight = 1336,
  CombplatehLowerRight = 1337,
  CombplatehUpperLeft = 1338,
  CombplatehUpperRight = 1339,
  CombplatersLowerLeft = 1340,
  CombplatersLowerRight = 1341,
  CombplatersUpperLeft = 1342,
  CombplatersUpperRight = 1343,
  CombplatevLowerLeft = 1344,
  CombplatevLowerRight = 1345,
  CombplatevUpperLeft = 1346,
  CombplatevUpperRight = 1347,
  DriveChainm1 = 1348,
  DriveChainm2 = 1349,
  EgressRestriction = 1350,
  EmergencyStopLowerPit = 1351,
  EmergencyStopUpperPit = 1352,
  FireRelay = 1353,
  GearboxOilLevelm1 = 1354,
  GearboxOilLevelm2 = 1355,
  HandrailElongationLeft = 1356,
  HandrailElongationRight = 1357,
  HandrailGuideControlLeft = 1358,
  HandrailGuideControlRight = 1359,
  HandrailInletLowerLeft = 1360,
  HandrailInletLowerRight = 1361,
  HandrailInletUpperLeft = 1362,
  HandrailInletUpperRight = 1363,
  HandrailSpeedLeft = 1364,
  HandrailSpeedRight = 1365,
  KeysSwitchTimeoutButton = 1366,
  LongBrakingDistanceFault = 1367,
  LowerUserStop = 1368,
  MissingStepLower = 1369,
  MissingStepUpper = 1370,
  OilLevelLow = 1371,
  OpenPitLower = 1372,
  OpenPitUpper = 1373,
  OverloadFaultM1 = 1374,
  OverloadFaultM2 = 1375,
  OverSpeedInMainShaft = 1376,
  PawlBrake = 1377,
  PtlLowerKeyFault = 1378,
  PtlUpperKeyFault = 1379,
  RadarBottomLeft = 1380,
  RadarBottomRight = 1381,
  RadarTopLeft = 1382,
  RadarTopRight = 1383,
  SafetyCircuitRelay = 1384,
  SeismicDetector = 1385,
  ShortBrakingDistanceFlt = 1386,
  SkirtLowerLeft = 1387,
  SkirtLowerRight = 1388,
  SkirtMiddleLeft = 1389,
  SkirtMiddleRight = 1390,
  SkirtUpperLeft = 1391,
  SkirtUpperRight = 1392,
  SpeedFault = 1393,
  StepChainLock = 1394,
  StepSagLower = 1395,
  StepSagUpper = 1396,
  StepUpThrustMonitorLeft = 1397,
  StepUpThrustMonitorRight = 1398,
  StopRemote = 1399,
  SubspeedInMainShaft = 1400,
  ThermalProtectionM1 = 1401,
  ThermalProtectionM2 = 1402,
  UpperUserStop = 1403,
  CombPlateHLowerLeft = 1404,
  BrakeWearLeftM1 = 1405,
  DoorTimeClose = 1406,
  DoorTimeOpen = 1407,
  HallButtonProtection = 1408,
  CounterWeightDerailment = 1409,
  DriveFault = 1410,
}
